var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueSlickCarousel',{staticClass:"gallery",attrs:{"slidesToShow":4,"slidesToScroll":1,"arrows":false}},_vm._l((_vm.slides),function(slide,i){return _c('PartMediaItem',{key:`galslide-${i}`,staticClass:"gallery__item",attrs:{"src":slide,"size":"square","lazyloading":""}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }